<div class="menu" [wbo-css-var]="{'--colNum': (model.numOfColumns$ | async)}">
    <div *ngIf="model.showPrevPage" class="menu-item"
         (dragleave)="dragleavePrev()" (drop)="dragleavePrev()">
        <wbo-screen-layout-button [icon]="'chevron-left'" (click)="model.previousMenuPage()"
                                  [item]="{itemType: ITEM_TYPE.MENU_PREV}"
                                  [actionButton]="true"></wbo-screen-layout-button>
    </div>
    <div [draggable]="true" (dragstart)="dragstart($event, item)" (drop)="drop($event, item)" (dragend)="dragend()"
         *ngFor="let item of (model.pageItems$ | async)" [ngClass]="{'toggled': item === toggledItem}"
         class="menu-item" draggable="true">
        <wbo-screen-layout-touch-item (commandsToggled$)="commandsToggled($event, item)"
                                      [item]="item"></wbo-screen-layout-touch-item>
    </div>
    <div *ngIf="model.showNextPage" class="menu-item"
         (dragleave)="dragleaveNext()" (drop)="dragleaveNext()">
        <wbo-screen-layout-button [icon]="'chevron-right'" (click)="model.nextMenuPage()"
                                  [item]="{itemType: ITEM_TYPE.MENU_NEXT}"
                                  [actionButton]="true"></wbo-screen-layout-button>
    </div>
</div>
